import { Injectable } from '@angular/core';
import { HttpClientService } from 'src/app/common/services/http-client-service';
import { ApiNameList } from 'src/environments/api-name-list';

@Injectable()
export class LoginInfoService {
    public baseUrl = '';
    constructor(public httpClientService: HttpClientService) {
        this.baseUrl = ApiNameList.restApi.baseUrl;
    }

    getUserAccount(): any {
        return this.httpClientService.get(this.baseUrl + ApiNameList.restApi.getUserAccount);
    }

    updateUserAccount(email: string): any {
        const requestObj = {
            email
        };
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.updateUserAccount, requestObj);
    }

    changePassword(oldPassword: string, newPassword: string, userId: string): any {
        const requestObj = {
           // userId: userId,
            oldPassword: oldPassword,
            newPassword: newPassword,
            portal: "student"
        };
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.changePasswordOkta, requestObj);
    }
}
